export default __webpack_public_path__ + "static/media/tank.9373a515.png";